module.exports = __webpack_public_path__ + "img/two1.a9c91e13.png";